import { fetchJsonByDelete, fetchJsonByGet, fetchJsonByPost, fetchJsonByPut } from './execute';
import { getParams } from '../reducers/analyticsApp';

export const fetchLabels = () => (dispatch, getState) =>
  fetchJsonByGet('/labels/list', getParams(getState())).then((response) => ({
    labels: response,
  }));

export const updateLabelFromState = (label) => (dispatch, getState) => {
  const state = getState();

  return fetchJsonByPut('/labels', label, getParams(state)).then((response) => ({
    label: response,
  }));
};

export const createLabel = (label) => (dispatch, getState) => {
  const state = getState();

  return fetchJsonByPost('/labels', label, getParams(state)).then((response) => ({
    label: response,
  }));
};

export const updateLabel = (label) => (dispatch, getState) =>
  fetchJsonByPut('/labels', label, getParams(getState())).then((response) => ({
    label: response,
  }));

export const deleteLabel = (id) => (dispatch, getState) =>
  fetchJsonByDelete(`/labels/${id}`, getParams(getState())).then((response) => ({
    id: response.id,
  }));
